import Accordion from "./Accordion";

const els = document.querySelectorAll('.accordion');

for (let el of els) {
    Accordion(el);
}
